import { makeStyles } from '@material-ui/core'

const loginUseStyles = makeStyles({
  body: {
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    padding: '20px 0',
    backgroundImage: 'url("/login-bg.webp")',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'center'
  },
  boxContainer: {
    margin: 'auto',
    boxShadow: '0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)',
    borderRadius: 10,
    backgroundColor: '#fff',
    padding: 50,
    width: 'calc(100% - 48px)',
    maxWidth: 500
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    justifyContent: 'center',
    '& img': {
      width: 26
    },
    '& h2': {
      fontSize: 20,
      fontWeight: 600,
      color: '#333',
      margin: 0
    }
  },
  infoLogin: {
    color: '#555',
    textAlign: 'center',
    marginTop: 16
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    marginTop: 30
  },
  formControl: {
    '& label': {
      fontSize: 16,
      color: '#333'
    },
    '& input': {
      padding: '8px 15px',
      borderRadius: 5,
      border: '1px solid #bbb',
      fontSize: 16,
      color: '#333',
      display: 'block',
      width: '100%',
      outline: 'none',
      '&:focus': {
        borderColor: '#333'
      }
    },
    '& select': {
      padding: '8px 15px',
      borderRadius: 5,
      border: '1px solid #bbb',
      fontSize: 16,
      color: '#333',
      display: 'block',
      width: '100%',
      outline: 'none'
    }
  },
  button: {
    backgroundColor: 'black',
    padding: '12px 0',
    cursor: 'pointer',
    borderRadius: 5,
    color: 'white',
    border: 'none',
    fontSize: 14,
    fontWeight: 'bold',
    width: '100%',
    marginTop: 8,
    '&:hover': {
      opacity: '0.8'
    },
    '&:disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed',
      '&:hover': {
        opacity: 1
      }
    }
  },
  passwordInput: {
    position: 'relative',

    '& input': {
      paddingRight: 40
    }
  }
})

export { loginUseStyles }
